import { Injectable, OnInit } from '@angular/core';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root', // Adjust scope as needed
})
export class DataSecurityService {
    private tenantId = localStorage.getItem("tenantId");
    private branchId = localStorage.getItem("branchId");
    private userType = localStorage.getItem("userType");
    accessEditDate: any
    AdminAccess: boolean
    InitialAccess : boolean
    UserTypeId: any

    ipAccessEditDate: any
    ipAdminAccess: boolean
    ipInitialAccess : boolean
    ipUserTypeId: any

    protected readonly unsubscribe$ = new Subject<void>();
    constructor(protected rolesService: RolesData) {

    }

    Apifunction(taskId: any) {

        this.rolesService.list(`clinicalDataSecurityDet/GetClinicalDataSecurityDetByIsActive?tenantId=${this.tenantId}&branchId=${this.branchId}&UserTypeId=${this.userType}&taskId=${taskId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            const allData = data.details
            const someData = data.details

            if(allData.length === 0){
                this.InitialAccess = true
            }else{
                this.InitialAccess = false
            }
            this.AdminAccess = someData.some(x => x.specialKey === true)
            this.accessEditDate = allData.reduce((acc, value) => {
                return (acc = acc > value.opLockTime ? acc : value);
            }, 0);
        })

    }



    ipApiFunction(taskId: any) {

        this.rolesService.list(`clinicalDataSecurityDet/GetClinicalDataSecurityDetByIsActive?tenantId=${this.tenantId}&branchId=${this.branchId}&UserTypeId=${this.userType}&taskId=${taskId}`).subscribe((data: any) => {
            const allData = data.details
            const someData = data.details

            if(allData.length === 0){
                this.ipInitialAccess = true
            }else{
                this.ipInitialAccess = false
            }
            this.ipAdminAccess = someData.some(x => x.specialKey === true)
            this.ipAccessEditDate = allData.reduce((acc, value) => {
                return (acc = acc > value.ipLockTime ? acc : value);
            }, 0);
        },
        (error) => {
            console.error('API Error:', error);
          }
    )

    }
}
